/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Content_DescriptionInputs */

const en_score_content_description = /** @type {(inputs: Score_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The most important thing is the content of your resume: What exactly did you learn during your studies, internships, or jobs? What are your achievements, what skills do you have? Here it is important to give details that match the job requirements as closely as possible. Based on this information, recruiters can assess whether you can successfully handle the tasks of a position.`)
};

const de_score_content_description = /** @type {(inputs: Score_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am wichtigsten sind die Inhalte deines Lebenslaufs: Was genau hast du im Studium, in Praktika oder Jobs gelernt? Was sind Erfolge, welche Kenntnisse hast du? Hier ist es wichtig, Details zu nennen, die möglichst gut zu den Stellenanforderungen passen. Anhand dieser Informationen können Recruiter einschätzen, ob du die Aufgaben einer Stelle erfolgreich bewältigen kannst.`)
};

/**
* | output |
* | --- |
* | "The most important thing is the content of your resume: What exactly did you learn during your studies, internships, or jobs? What are your achievements, wha..." |
*
* @param {Score_Content_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_content_description = /** @type {((inputs?: Score_Content_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Content_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_content_description(inputs)
	return en_score_content_description(inputs)
});